import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { fmtDate } from "@/lib/format";

export default function NotesPanel({ notes = [], onAdd }) {
  const [text, setText] = useState("");
  const add = async () => {
    if (!text.trim()) return;
    await onAdd(text.trim());
    setText("");
  };
  return (
    <div>
      <div className="space-y-2 max-h-40 overflow-y-auto mb-2">
        {(notes || []).length ? (
          notes.map((n, i) => (
            <div key={i} className="text-xs bg-[var(--panel-2)] border border-[var(--border-lch)] rounded p-2">
              <div className="text-[var(--text)]">{n.note}</div>
              <div className="text-[var(--muted)] mt-1">{fmtDate(n.at)}</div>
            </div>
          ))
        ) : (
          <p className="text-xs text-[var(--muted)]">No notes yet.</p>
        )}
      </div>
      <Textarea rows={2} placeholder="Add an internal note…" value={text}
        onChange={(e) => setText(e.target.value)} className="bg-[var(--panel)]" data-testid="note-input" />
      <Button size="sm" variant="outline" className="mt-2" onClick={add} data-testid="add-note-btn">Add Note</Button>
    </div>
  );
}
